class UserSettingsCtrl {
    
    constructor($scope, $rootScope, UserService, Notification, EVENTS, $uibModal) {

        this.UserService = UserService;
        this.Notification = Notification;
        this.EVENTS = EVENTS;
        this.$uibModal = $uibModal;
        this.$scope = $scope;

        $scope.changePassword = () => this.changePassword();

    }
    
    changePassword() {

        var modalInstance = this.$uibModal.open({
            animation: true,
            templateUrl: 'admin/change-password.html',
            controller: 'AddItemCtrl'
        });

        modalInstance.result.then((newItem) => {
            this.$UserService.changeOwnPassword(newItem.password)
                .then((response) => {
                    this.$scope.$emit(this.EVENTS.SHOW_NOTIFICATION, {'message': 'Password updated.'});
                }, (response) => {
                    console.error(response);
                    console.error(response);
                });
        });
    }
    
}

angular.module('cpm')
    .controller('UserSettingsCtrl', ['$scope', "$rootScope", 'UserService', 'Notification', 'EVENTS', '$uibModal', UserSettingsCtrl]);
